<template>
<m-pageframe
  title="Home"
>
    <v-overlay
        
        opacity="0.3"
        z-index="10"
    >
        <v-progress-circular
        :size="70"
        :width="7"
        color="primary"
        indeterminate
        ></v-progress-circular>
    </v-overlay>
</m-pageframe>
</template>

<script>

export default {
    mounted () {

        if ( !this.$rc.$state.isSignedIn() )
        {
            this.$router.replace({
                    'name' : 'sign-in',
                })
            .catch(e=>{});

            return;
        }
        
        let employee_id = this.$route.params.employee_id;

        
        
        this.$rc.completeSignInAs(
                employee_id,
            
                (data) => {
                    
                    let route = {'name': 'home'};
                   
                    let after_route = this.$route.query == null ? null : this.$route.query.after_route;

                    if ( after_route != null )
                    {
                        route = JSON.parse(after_route);
                    }

                    this.$router.push(route);
                    
                    return;
                },
            
                () => {
                    this.$rc.alert('Error','Unable to sign in as');

                    return;
                },
            );
    },
}
</script>

<style lang="scss" scoped>

</style>